
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Constants.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export class LogEntryStatus {
	static none: LogEntryStatusType = '';
	static meeting: LogEntryStatusType = 'meeting';
	static dialog: LogEntryStatusType = 'dialog';
	static noResponse: LogEntryStatusType = 'no-response';
	static rejected: LogEntryStatusType = 'rejected';
	static rescheduledMeeting: LogEntryStatusType = 'rescheduled-meeting';
	static meetingCancelled: LogEntryStatusType = 'meeting-cancelled';
	static createSale: LogEntryStatusType = 'create-sale';
	static mailSent: LogEntryStatusType = 'mail-sent';
	static event: LogEntryStatusType = 'event';
	static mailReceived: LogEntryStatusType = 'mail-received';
	static system: LogEntryStatusType = 'system';
	static offerRejected: LogEntryStatusType = 'offer-rejected';
	static offerSent: LogEntryStatusType = 'offer-sent';
	static mailOfferRejected: LogEntryStatusType = 'mail-offer-rejected';
	static settlementSent: LogEntryStatusType = 'settlement-sent';
	static settlementConfirmed: LogEntryStatusType = 'settlement-confirmed';
	static settlementReminder: LogEntryStatusType = 'settlement-reminder';

	static values = ['', 'meeting', 'dialog', 'no-response', 'rejected', 'rescheduled-meeting', 'meeting-cancelled', 'create-sale', 'mail-sent', 'event', 'mail-received', 'system', 'offer-rejected', 'offer-sent', 'mail-offer-rejected', 'settlement-sent', 'settlement-confirmed', 'settlement-reminder'];
}
export type LogEntryStatusType = '' | 'meeting' | 'dialog' | 'no-response' | 'rejected' | 'rescheduled-meeting' | 'meeting-cancelled' | 'create-sale' | 'mail-sent' | 'event' | 'mail-received' | 'system' | 'offer-rejected' | 'offer-sent' | 'mail-offer-rejected' | 'settlement-sent' | 'settlement-confirmed' | 'settlement-reminder';

